module.exports = __webpack_public_path__ + "img/parallax2-1024p.050123d1.jpg";